import { Button, Modal, Progress, Spin, Tooltip, Upload } from "antd";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { FaCloudUploadAlt } from "react-icons/fa";
import { toast } from "react-toastify";
import * as Yup from "yup";
import umbuslogo from "../../../asserts/umbuslogo.png";
import {
  GetSuperAdminDocumentById,
  SubmitAddressData,
  SubmitCompanyData,
  SubmitBusData,
  GetOperatorData,GetSuperAdminData,GetSuperAdminById,GetOperatorById
} from "../../../Api/UserManagement/SuperAdmin";
import { useDispatch } from "react-redux";

const FILE_SIZE = 1024 * 1024 * 5; // 5MB
const SUPPORTED_FORMATS = [
  "application/pdf",
  "image/jpg",
  "image/jpeg",
  "image/png",
];

const validationSchema = Yup.object().shape({
  bus_img1: Yup.mixed()
    .required("Bus Image 1 is required")
    .test("fileSize", "File too large max 5mb", (value) =>
      typeof value === "string" ? true : value && value.size <= FILE_SIZE
    )
    .test("fileFormat", "Unsupported Format", (value) =>
      typeof value === "string"
        ? true
        : value && SUPPORTED_FORMATS.includes(value.type)
    ),
  bus_img2: Yup.mixed()
    .required("Bus Image 2  is required")
    .test("fileSize", "File too large max 5mb", (value) =>
      typeof value === "string" ? true : value && value.size <= FILE_SIZE
    )
    .test("fileFormat", "Unsupported Format", (value) =>
      typeof value === "string"
        ? true
        : value && SUPPORTED_FORMATS.includes(value.type)
    ),
  bus_img3: Yup.mixed()
    .required("Bus Image 3 is required")
    .test("fileSize", "File too large max 5mb", (value) =>
      typeof value === "string" ? true : value && value.size <= FILE_SIZE
    )
    .test("fileFormat", "Unsupported Format", (value) =>
      typeof value === "string"
        ? true
        : value && SUPPORTED_FORMATS.includes(value.type)
    ),
  bus_img4: Yup.mixed()
    .required("Bus Image 4 is required")
    .test("fileSize", "File too large max 5mb", (value) =>
      typeof value === "string" ? true : value && value.size <= FILE_SIZE
    )
    .test("fileFormat", "Unsupported Format", (value) =>
      typeof value === "string"
        ? true
        : value && SUPPORTED_FORMATS.includes(value.type)
    ),
bus_img5: Yup.mixed()
    .required("Bus Image 5 is required")
    .test("fileSize", "File too large max 5mb", (value) =>
      typeof value === "string" ? true : value && value.size <= FILE_SIZE
    )
    .test("fileFormat", "Unsupported Format", (value) =>
      typeof value === "string"
        ? true
        : value && SUPPORTED_FORMATS.includes(value.type)
    ),
    bus_img6: Yup.mixed()
    .required("Bus Image 6 is required")
    .test("fileSize", "File too large max 5mb", (value) =>
      typeof value === "string" ? true : value && value.size <= FILE_SIZE
    )
    .test("fileFormat", "Unsupported Format", (value) =>
      typeof value === "string"
        ? true
        : value && SUPPORTED_FORMATS.includes(value.type)
    ),
});

export default function AddBusImage({
  setCurrentpage,
  currentpage,

  operatorID,
  
  gstback,

  setDocumentBack,
  updatedata,
  setModalIsOpen,
   setOperatorID,
   setSuperAdminData,
}) {
  const apiImgUrl = process.env.REACT_APP_API_URL_IMAGE;

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [spinning, setSpinning] = useState(false);

  const [inputPreview, setInputPreview] = useState({
    bus_img1: null,
    bus_img2: null,
    bus_img3: null,
    bus_img4: null,
    bus_img5: null,
    bus_img6:null,
  });

const handleFileChange = (
  event,
  key,
  setFieldValue,
  setFieldTouched,
  setInputPreview
) => {
  const file = event?.currentTarget?.files[0];

  if (file) {
    setInputPreview((prev) => ({
      ...prev,
      [key]: URL.createObjectURL(file),
    }));

    setFieldValue(key, file);
    setFieldTouched(key, true);
  }
};


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);

  const openModal = (event) => {
    // Get the image source (src) using `getElementById`
    const imageSrc = event.target.getAttribute("src");

    // Set the modal image source
    setModalImage(imageSrc);

    // Open the modal
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const dispatch = useDispatch();
  const handleSubmit = async (values) => {
    try {
      if (
        (operatorID && enable == false && gstback == true) ||
        (updatedata &&
          superadminbusdata.bus_img1 != null &&
          enable == false)
      ) {
        // setCurrentpage(5); // Assuming setCurrentPage is a function in your component
      } else {
        const data = await SubmitBusData(
          values,
          operatorID,
          enable,
          dispatch
        ); // Replace with actual API call function
        toast.success("Bus Images Updated Successfully");
        setModalIsOpen(false);
     
      }
    } catch (error) {
      console.error("Error uploading data", error);
      toast.error("Failed to submit document. Please try again."); // Notify user of error
    }
    
  };
  console.log(currentpage, "currentpagecurrentpage");
  const handleCancel = () => setPreviewOpen(false);
  const [superadminbusdata, setSuperAdminBusData] = useState({});
  const [enable, setEnable] = useState(false);

const fetchGetUser = async () => {
  try {
    const data = await GetOperatorById(
      operatorID,
      setOperatorID,
      setSuperAdminData,
      dispatch,
      setSpinning
    );

    console.log(data, "First bus image");

    if (Array.isArray(data) && data.length > 0) {
      setSuperAdminBusData(data[0]); // ✅ Set the first object
    } else {
      console.warn("No operator data found");
      setSuperAdminBusData(null); // or set default empty object
    }

  } catch (error) {
    console.error("Error fetching additional user data", error);
  }
};


  useEffect(() => {
    setInputPreview({
   bus_img1:superadminbusdata.bus_img1,
        bus_img2:superadminbusdata.bus_img2,
        bus_img3:superadminbusdata.bus_img3,
        bus_img4:superadminbusdata.bus_img4,
        bus_img5:superadminbusdata.bus_img5,
        bus_img6:superadminbusdata.bus_img6
    });
  }, [superadminbusdata]);

  useEffect(() => {
    if (operatorID != null || enable || gstback) {
     fetchGetUser();
    }
  }, [
    operatorID,
    setOperatorID,
    setSuperAdminBusData,
  ]);

  console.log(inputPreview, "preview")
  return (
    <div>
      <div className="border-l-[0.1vw]  relative  px-[2vw] border-t-[0.1vw] border-b-[0.3vw] border-r-[0.1vw] rounded-[1vw] border-[#1f4b7f] mt-[1vw] ">
        <div className="w-[5vw] h-[5vw] bg-white shadow-lg rounded-full absolute left-[16.6vw] top-[-2.5vw] flex justify-center items-center">
          <img className="" src={umbuslogo} alt="buslogo" />
        </div>
        <div className="h-[4vw] w-full flex items-center justify-between">
          <label className="text-[1.5vw] font-semibold text-[#1f4b7f]">
            Bus Images
          </label>
          {(updatedata && superadminbusdata.bus_img1 != null) ||
          gstback ? (
            <button
              className={`${
                enable
                  ? "bg-[#1f4b7f] text-white"
                  : "text-[#1f4b7f] bg-white border-[#1f4b7f]"
              } rounded-full font-semibold w-[10vw] h-[2vw] flex items-center justify-center border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] border-r-[0.1vw] text-[1.1vw] `}
              onClick={() => setEnable(!enable)}
            >
              Enable to Edit
            </button>
          ) : (
            ""
          )}
        </div>
        <div className="pb-[1vw]">
          {/* <img src={`http://192.168.90.47:4000${inputPreview.aadharfr}`}/> */}
          <div className="border-b-[0.1vw] w-full border-[#1f4b7f]"></div>
        </div>
       
         <Formik
    initialValues={{
      bus_img1: superadminbusdata.bus_img1 || null,
      bus_img2: superadminbusdata.bus_img2 || null,
      bus_img3: superadminbusdata.bus_img3 || null,
      bus_img4: superadminbusdata.bus_img4 || null,
      bus_img5: superadminbusdata.bus_img5 || null,
      bus_img6: superadminbusdata.bus_img6 || null,
    }}
          validationSchema={validationSchema}
          validateOnBlur={false}
  validateOnChange={true}
          onSubmit={(values) => {
            handleSubmit(values);
          }}
          enableReinitialize
          
        >
          {({ isSubmitting, isValid, setFieldValue, values, handleChange,setFieldTouched }) => (
            <Form>
              {spinning ? (
                <div className=" flex justify-center h-[22.5vw] items-center">
                  <Spin size="large" />
                </div>
              ) : (
                <div>
                  <div className="gap-y-[1.2vw] flex-col flex">
                    <div className="grid grid-cols-2 w-full  gap-x-[1.5vw]">
                      <div className="col-span-1">
                        <label className="text-[#1F4B7F] text-[1.1vw]">
                          Bus Image 1
                          <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                            *
                          </span>
                          <span className="text-[#909193] text-[0.7vw] font-bold pl-[0.25vw]">
                {`(Max Size:5MB)`}
              </span>
                        </label>
                        <div className="relative">
                          <input
                            id="bus_img1"
                            name="bus_img1"
                            accept=".jpg, .jpeg, .png"
                            type="file"
                            style={{ display: "none" }}
                            onClick={(e) => {
                              e.target.value = null;
                            }}
                             onChange={(event) => {handleFileChange(event,"bus_img1",setFieldValue,setFieldTouched,setInputPreview)
  
                              // setInputPreview(
                              //   URL.createObjectURL(event.currentTarget.files[0])
                              // );
                              // setInputPreview(state => ({
                              //   ...state,
                              //   aadharfr: URL?.createObjectURL(event?.currentTarget?.files[0])
                              // }))
                            }}
                            disabled={
                              (updatedata &&
                                superadminbusdata.bus_img1 !=
                                  null) ||
                              gstback
                                ? enable
                                  ? false
                                  : true
                                : false
                            }
                          />
                          <button
                            type="button"
                            className={`${
                              (updatedata &&
                                superadminbusdata.bus_img1 !=
                                  null) ||
                              gstback
                                ? enable == false
                                  ? " cursor-not-allowed"
                                  : ""
                                : ""
                            } border-r-[0.3vw] relative flex items-center justify-between px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                            onClick={(event) => {
                              event.preventDefault();
                              document.getElementById("bus_img1").click();
                            }}
                          >
                            <span className="opacity-50 font-sans">
                              Upload Bus Image 1
                            </span>
                            {/* {inputPreview?.aadharfr  ? (
                          inputPreview?.aadharfr?.startsWith("blob") ? (
                            <img
                            src={inputPreview.aadharfr}
                            className="h-[2.5vw] w-[2.5vw] absolute right-[1vw]"
                            alt="Aadhar Front"
                          />
                          ) : (
                            <img
                            src={`http://192.168.90.47:4000${inputPreview.aadharfr}`}
                            className="h-[2.5vw] w-[2.5vw] absolute right-[1vw]"
                            alt="Aadhar Front"
                          />
                          )
                        ) : (
                          <FaCloudUploadAlt
                            color="#1F487C"
                            size="2vw"
                            className="absolute right-[1vw]"
                          />
                        )} */}

                            {/* {inputPreview.aadharfr != null ? (
                          <img
                            // src={`http://192.168.90.47:4000${inputPreview.aadharfr}` || inputPreview.aadharfr}
                            src={inputPreview.aadharfr}
                            className=" h-[2.5vw] w-[2.5vw] absolute right-[1vw]"
                          />
                        ) : (
                          <FaCloudUploadAlt
                            color="#1F487C"
                            size={"2vw"}
                            className="absolute right-[1vw]"
                          />
                        )} */}
                          </button>
                          {inputPreview?.bus_img1 ? (
                            inputPreview?.bus_img1?.startsWith("blob") ? (
                              <img
                                src={inputPreview.bus_img1}
                                className="h-[2.5vw] w-[2.5vw] absolute cursor-zoom-in top-[.2vw]  right-[.3vw]"
                                alt="Bus Image1"
                                onClick={openModal}
                              />
                            ) : (
                              <img
                                src={`${apiImgUrl}${inputPreview.bus_img1}`}
                                className="h-[2.5vw] w-[2.5vw] absolute  top-[.2vw] cursor-zoom-in right-[.3vw]"
                                alt="Bus Image 1"
                                onClick={openModal}
                              />
                            )
                          ) : (
                            <FaCloudUploadAlt
                              color="#1F487C"
                              size="2vw"
                              className="absolute right-[1vw] top-[.4vw] pointer-events-none"
                            />
                          )}

                          <ErrorMessage
                            name="bus_img1"
                            component="div"
                            // style={{ color: "red" }}
                            className="text-[0.8vw] text-red-500 absolute bottom-[-1.25vw]"
                          />
                        </div>
                      </div>
                 
                      <div className="col-span-1">
                        <label className="text-[#1F4B7F] text-[1.1vw]">
                          Bus Image 2
                          <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                            *
                          </span>
                          <span className="text-[#909193] text-[0.7vw] font-bold pl-[0.25vw]">
                {`(Max Size:5MB)`}
              </span>
                        </label>
                        <div className="relative">
                          <input
                            id="bus_img2"
                            name="bus_img2"
                            accept=".jpg, .jpeg, .png"
                            type="file"
                            style={{ display: "none" }}
                            onClick={(e) => {
                              e.target.value = null;
                            }}
                            onChange={(event) => {
                              handleFileChange(event,"bus_img2",setFieldValue,setFieldTouched,setInputPreview)
                            }}
                            disabled={
                              (updatedata &&
                                superadminbusdata.bus_img1 !=
                                  null) ||
                              gstback
                                ? enable
                                  ? false
                                  : true
                                : false
                            }
                          />
                          <button
                            type="button"
                            className={`${
                              (updatedata &&
                                superadminbusdata.bus_img1 !=
                                  null) ||
                              gstback
                                ? enable == false
                                  ? "cursor-not-allowed"
                                  : ""
                                : ""
                            }  border-r-[0.3vw] relative flex items-center justify-between px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                            onClick={(event) => {
                              event.preventDefault();
                              document.getElementById("bus_img2").click();
                            }}
                          >
                            <span className="opacity-50 font-sans">
                              Upload Bus Image 2
                            </span>
                      
                          </button>
                          {inputPreview?.bus_img2? (
                            inputPreview?.bus_img2?.startsWith("blob") ? (
                              <img
                                src={inputPreview.bus_img2}
                                className="h-[2.5vw] w-[2.5vw] absolute cursor-zoom-in top-[.2vw]  right-[.3vw]"
                                alt="Bus Image2"
                                onClick={openModal}
                              />
                            ) : (
                              <img
                                src={`${apiImgUrl}${inputPreview.bus_img2}`}
                                className="h-[2.5vw] w-[2.5vw] absolute  top-[.2vw] cursor-zoom-in right-[.3vw]"
                                alt="Bus Image 2"
                                onClick={openModal}
                              />
                            )
                          ) : (
                            <FaCloudUploadAlt
                              color="#1F487C"
                              size="2vw"
                              className="absolute right-[1vw] top-[.4vw] pointer-events-none"
                            />
                          )}
                       
                          <ErrorMessage
                            name="bus_img2"
                            component="div"
                            // style={{ color: "red" }}
                            className="text-[0.8vw] text-red-500 absolute bottom-[-1.25vw]"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-x-[1.5vw]">
                      <div className="col-span-1">
                        <label className="text-[#1F4B7F] text-[1.1vw]">
                          Bus Image 3
                          <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                            *
                          </span>
                          <span className="text-[#909193] text-[0.7vw] font-bold pl-[0.25vw]">
                {`(Max Size:5MB)`}
              </span>
                        </label>
                        <div className="relative">
                          <input
                            id="bus_img3"
                            name="bus_img3"
                            type="file"
                            accept=".jpg, .jpeg, .png"
                            style={{ display: "none" }}
                            onClick={(e) => {
                              e.target.value = null;
                            }}
                            onChange={(event) => {
                              handleFileChange(event,"bus_img3",setFieldValue,setFieldTouched,setInputPreview)
                            }}
                            disabled={
                              (updatedata &&
                                superadminbusdata.bus_img1 !=
                                  null) ||
                              gstback
                                ? enable
                                  ? false
                                  : true
                                : false
                            }
                          />
                          <button
                            type="button"
                            className={`${
                              (updatedata &&
                                superadminbusdata.bus_img1 !=
                                  null) ||
                              gstback
                                ? enable == false
                                  ? " cursor-not-allowed"
                                  : ""
                                : ""
                            }  border-r-[0.3vw] relative flex items-center justify-between px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                            onClick={(event) => {
                              event.preventDefault();
                              document.getElementById("bus_img3").click();
                            }}
                          >
                            <span className="opacity-50 font-sans">
                              Upload Bus Image 3
                            </span>
                        
                          </button>
                          {inputPreview?.bus_img3 ? (
                            inputPreview?.bus_img3?.startsWith("blob") ? (
                              <img
                                src={inputPreview.bus_img3}
                                className="h-[2.5vw] w-[2.5vw] absolute cursor-zoom-in top-[.2vw]  right-[.3vw]"
                                alt="Bus Image3"
                                onClick={openModal}
                              />
                            ) : (
                              <img
                                src={`${apiImgUrl}${inputPreview.bus_img3}`}
                                className="h-[2.5vw] w-[2.5vw] absolute  top-[.2vw] cursor-zoom-in right-[.3vw]"
                                alt="Bus Image 3"
                                onClick={openModal}
                              />
                            )
                          ) : (
                            <FaCloudUploadAlt
                              color="#1F487C"
                              size="2vw"
                              className="absolute right-[1vw] top-[.4vw] pointer-events-none"
                            />
                          )}
                       
                          <ErrorMessage
                            name="bus_img3"
                            component="div"
                            // style={{ color: "red" }}
                            className="text-[0.8vw] text-red-500 absolute bottom-[-1.25vw]"
                          />
                        </div>
                      </div>
                      <div className="col-span-1">
                        <label className="text-[#1F4B7F] text-[1.1vw]">
                          Bus Image 4
                          <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                            *
                          </span>
                          <span className="text-[#909193] text-[0.7vw] font-bold pl-[0.25vw]">
                {`(Max Size:5MB)`}
              </span>
                        </label>
                        <div className="relative">
                          <input
                            id="bus_img4"
                            name="bus_img4"
                            type="file"
                            accept=".jpg, .jpeg, .png"
                            style={{ display: "none" }}
                            onClick={(e) => {
                              e.target.value = null;
                            }}
                            onChange={(event) => {
                              handleFileChange(event,"bus_img4",setFieldValue,setFieldTouched,setInputPreview)
                            }}
                            disabled={
                              (updatedata &&
                                superadminbusdata.bus_img1 !=
                                  null) ||
                              gstback
                                ? enable
                                  ? false
                                  : true
                                : false
                            }
                          />
                          <button
                            type="button"
                            className={`${
                              (updatedata &&
                                superadminbusdata.bus_img1 !=
                                  null) ||
                              gstback
                                ? enable == false
                                  ? " cursor-not-allowed"
                                  : ""
                                : ""
                            }  border-r-[0.3vw] relative flex items-center justify-between px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                            onClick={(event) => {
                              event.preventDefault();
                              document.getElementById("bus_img4").click();
                            }}
                          >
                            <span className="opacity-50 font-sans">
                              Upload Bus Image 4
                            </span>
                         
                          </button>
                          {inputPreview?.bus_img4 ? (
                            inputPreview?.bus_img4?.startsWith("blob") ? (
                              <img
                                src={inputPreview.bus_img4}
                                className="h-[2.5vw] w-[2.5vw] absolute cursor-zoom-in top-[.2vw]  right-[.3vw]"
                                alt="Bus Image 4"
                                onClick={openModal}
                              />
                            ) : (
                              <img
                                src={`${apiImgUrl}${inputPreview.bus_img4}`}
                                className="h-[2.5vw] w-[2.5vw] absolute  top-[.2vw] cursor-zoom-in right-[.3vw]"
                                alt="Bus Image 4"
                                onClick={openModal}
                              />
                            )
                          ) : (
                            <FaCloudUploadAlt
                              color="#1F487C"
                              size="2vw"
                              className="absolute right-[1vw] top-[.4vw] pointer-events-none"
                            />
                          )}
                        
                          <ErrorMessage
                            name="bus_img4"
                            component="div"
                            // style={{ color: "red" }}
                            className="text-[0.8vw] text-red-500 absolute bottom-[-1.25vw]"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-x-[1.5vw]">
                      <div className="col-span-1">
                        <label className="text-[#1F4B7F] text-[1.1vw]">
                          Bus Image 5
                          <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                            *
                          </span>
                          <span className="text-[#909193] text-[0.7vw] font-bold pl-[0.25vw]">
                {`(Max Size:5MB)`}
              </span>
                        </label>
                        <div className="relative">
                          <input
                            id="bus_img5"
                            name="bus_img5"
                            type="file"
                            accept=".jpg, .jpeg, .png"
                            style={{ display: "none" }}
                            onClick={(e) => {
                              e.target.value = null;
                            }}
                            onChange={(event) => {
                              handleFileChange(event,"bus_img5",setFieldValue,setFieldTouched,setInputPreview)
                            }}
                            disabled={
                              (updatedata &&
                                superadminbusdata.bus_img1 !=
                                  null) ||
                              gstback
                                ? enable
                                  ? false
                                  : true
                                : false
                            }
                          />
                          <button
                            type="button"
                            className={`${
                              (updatedata &&
                                superadminbusdata.bus_img1 !=
                                  null) ||
                              gstback
                                ? enable == false
                                  ? " cursor-not-allowed"
                                  : ""
                                : ""
                            }  border-r-[0.3vw] relative flex items-center justify-between px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                            onClick={(event) => {
                              event.preventDefault();
                              document.getElementById("bus_img5").click();
                            }}
                          >
                            <span className="opacity-50 font-sans">
                              Upload Bus Image 5
                            </span>
                          
                          
                          </button>
                          {inputPreview?.bus_img5 ? (
                            inputPreview?.bus_img5?.startsWith("blob") ? (
                              <img
                                src={inputPreview.bus_img5}
                                className="h-[2.5vw] w-[2.5vw] absolute cursor-zoom-in top-[.2vw]  right-[.3vw]"
                                alt="Bus Image5"
                                onClick={openModal}
                              />
                            ) : (
                              <img
                                src={`${apiImgUrl}${inputPreview.bus_img5}`}
                                className="h-[2.5vw] w-[2.5vw] absolute  top-[.2vw] cursor-zoom-in right-[.3vw]"
                                alt="Bus Image5"
                                onClick={openModal}
                              />
                            )
                          ) : (
                            <FaCloudUploadAlt
                              color="#1F487C"
                              size="2vw"
                              className="absolute right-[1vw] top-[.4vw] pointer-events-none"
                            />
                          )}
                       
                          <ErrorMessage
                            name="bus_img5"
                            component="div"
                            
                            className="text-[0.8vw] text-red-500 absolute bottom-[-1.25vw]"
                          />
                        </div>
                      </div>
                      <div className="col-span-1">
                        <label className="text-[#1F4B7F] text-[1.1vw]">
                          Bus Image 6
                          <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                            *
                          </span>
                          <span className="text-[#909193] text-[0.7vw] pl-[0.25vw] font-bold">
                {`(Max Size:5MB)`}
              </span>
                        </label>
                        <div className="relative">
                          <input
                            id="bus_img6"
                            name="bus_img6"
                            type="file"
                            accept=".jpg, .jpeg, .png"
                            style={{ display: "none" }}
                            onClick={(e) => {
                              e.target.value = null;
                            }}
                            onChange={(event) => {
                              handleFileChange(event,"bus_img6",setFieldValue,setFieldTouched,setInputPreview)
                            }}
                            disabled={
                              (updatedata &&
                                superadminbusdata.bus_img1 !=
                                  null) ||
                              gstback
                                ? enable
                                  ? false
                                  : true
                                : false
                            }
                          />
                          <button
                            type="button"
                            className={`${
                              (updatedata &&
                                superadminbusdata.bus_img1 !=
                                  null) ||
                              gstback
                                ? enable == false
                                  ? " cursor-not-allowed"
                                  : ""
                                : ""
                            }  border-r-[0.3vw] relative flex items-center justify-between px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                            onClick={(event) => {
                              event.preventDefault();
                              document.getElementById("bus_img6").click();
                            }}
                          >
                            <span className="opacity-50 font-sans">
                              Upload Bus Image 6
                            </span>
                          </button>
                          {inputPreview?.bus_img6 ? (
                            inputPreview?.bus_img6?.startsWith("blob") ? (
                              <img
                                src={inputPreview.bus_img6}
                                className="h-[2.5vw] w-[2.5vw] absolute cursor-zoom-in top-[.2vw]  right-[.3vw]"
                                alt="Bus Image 6"
                                onClick={openModal}
                              />
                            ) : (
                              <img
                                src={`${apiImgUrl}${inputPreview.bus_img6}`}
                                className="h-[2.5vw] w-[2.5vw] absolute  top-[.2vw] cursor-zoom-in right-[.3vw]"
                                alt="Bus Image 6"
                                onClick={openModal}
                              />
                            )
                          ) : (
                            <FaCloudUploadAlt
                              color="#1F487C"
                              size="2vw"
                              className="absolute right-[1vw] top-[.4vw] pointer-events-none"
                            />
                          )}
                      
                          <ErrorMessage
                            name="bus_img6"
                            component="div"
                            
                            className="text-[0.8vw] text-red-500 absolute bottom-[-1.25vw]"
                          />
                        </div>
                      </div>
                    </div>
                    
                  </div>
                  <div className="flex items-center left-0 px-[vw] w-full  bottom-0 gap-x-[1vw] justify-between mt-[3vw] pt-[0vw] py-[1vw]">
                    <div>
                      <h1 className="text-[#1F4B7F] text-[0.7vw] font-semibold">
                        *You must fill in all fields to be able to continue
                      </h1>
                    </div>
                    <div className="flex items-center gap-x-[1vw]">
                      <button
                        className="border-[#1F487C] w-[5vw] font-semibold text-[1vw] h-[2vw] rounded-full border-r-[0.2vw]  border-l-[0.1vw] border-t-[0.1vw] border-b-[0.2vw]"
                        onClick={() => {
                          setCurrentpage(1);
                          setDocumentBack(true);
                        }}
                      >
                        Back
                      </button>
                            <button
                          className={`bg-[#1F487C] font-semibold rounded-full w-[11vw] h-[2vw] text-[1vw] text-white `}
                          type="submit"
                          
                        >
                          Submit
                          
              
                        </button>
                    </div>
                  </div>
                </div>
              )}
            </Form>
          )}
        </Formik>

      
      </div>

      <Modal
        visible={isModalOpen}
        onCancel={closeModal}
        footer={null}
        centered
        
        bodyStyle={{ padding: 0 }}
        destroyOnClose={true} 
      >
       
        {modalImage && (
          <img
            src={modalImage}
            alt="Documents Preview"
            style={{ width: "100%" }}
            className=""
          />
        )}
      </Modal>
    </div>
  );
}
